import ThemeSwitcher from './ThemeSwitcher'

export default ThemeSwitcher
